<!--
  --
  -- 組織のフレームページ
  --
  -- 組織下のページはこの中で表示する
  --
  -->
<template>
  <v-app>
    <!-- ヘッダ -->
    <c-header :no-actions="noActions"/>

    <!-- メインコンテンツ -->
    <v-main class="workspace">
      <router-view />
    </v-main>

    <!-- フッタ -->
    <c-footer />
  </v-app>
</template>

<script>
import CHeader from './CHeader'
import CFooter from './CFooter'

import * as C from '@/consts'

export default {
  name: 'Org',
  components: {
    CHeader,
    CFooter
  },

  computed: {
    /**
     * ユーザメニュー等のアクションコンポーネントを非表示にするか
     */
    noActions () {
      const pageType = this.$route.meta.type
      if (pageType === C.PAGE_LOGIN) {
        // ログインページは常に非表示
        return true
      } else if (pageType === C.PAGE_REGISTER) {
        // 会員登録ページは未登録なら非表示
        return !this.getters['register/isRegistered']
      }
      return false
    }
  }
}
</script>
